class AbCompleteTheLook {
  constructor(el) {
    this.el = el;
    this.productId = el.dataset.productId;
    this.cardsEl = el.querySelector(`#ab-ctl-cards-${this.productId}`);
    this.prevBtn = el.querySelector('.ab-ctl-nav-btn--prev');
    this.nextBtn = el.querySelector('.ab-ctl-nav-btn--next');
    this.data = this._parseData();
    this.currentIndex = 0;
    this.activeCard = null;
    this._drawerImages = [];
    this._drawerImageIndex = 0;
    this._drawerCurrentUv = null;
    this._drawerCurrentVariantId = null;
    this._drawerCurrentSize = null;
    this._drawerCurrentExtra = null;

    const styles = getComputedStyle(this.el);
    const desktopCols = parseInt(styles.getPropertyValue('--ab-ctl-columns')) || 3;
    const mobileCols = parseInt(styles.getPropertyValue('--ab-ctl-mobile-columns')) || 1;
    this.cardsPerView = window.innerWidth < 750 ? mobileCols : desktopCols;

    this.drawer = this._createDrawer();

    this._attachCardListeners(this.cardsEl);
    this._attachNavListeners();
    this._attachSwipe();
    this._updateNav();
    this._watchVariantChange();

    const idInput = document.querySelector('[data-type="add-to-cart-form"] [name="id"]');
    const initialVariantId = idInput?.value || new URLSearchParams(location.search).get('variant');
    if (initialVariantId) this._updateCards(String(initialVariantId));
  }

  _parseData() {
    const el = document.getElementById(`ab-ctl-data-${this.productId}`);
    try { return JSON.parse(el?.textContent || '{}'); } catch { return {}; }
  }

  // ── Drawer ───────────────────────────────────────────────────────────────────

  _createDrawer() {
    const drawer = document.createElement('div');
    drawer.className = 'ab-ctl-drawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML = `
      <div class="ab-ctl-drawer__overlay"></div>
      <div class="ab-ctl-drawer__panel" role="dialog" aria-modal="true">
        <button type="button" class="ab-ctl-drawer__close" aria-label="Close">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
        <div class="ab-ctl-drawer__img-wrap">
          <div class="ab-ctl-drawer__img-track"></div>
          <button type="button" class="ab-ctl-drawer__img-nav ab-ctl-drawer__img-prev" aria-label="Previous image">
            <svg width="10" height="16" viewBox="0 0 10 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M8 1L2 8l6 7"/></svg>
          </button>
          <button type="button" class="ab-ctl-drawer__img-nav ab-ctl-drawer__img-next" aria-label="Next image">
            <svg width="10" height="16" viewBox="0 0 10 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M2 1l6 7-6 7"/></svg>
          </button>
        </div>
        <div class="ab-ctl-drawer__body">
          <a class="ab-ctl-drawer__title" href=""></a>
          <p class="ab-ctl-drawer__variant-summary"></p>
          <div class="ab-ctl-drawer__prices"></div>
          <div class="ab-ctl-drawer__desc-wrap">
            <div class="ab-ctl-drawer__desc"></div>
            <button type="button" class="ab-ctl-drawer__desc-toggle" aria-expanded="false" hidden>
              <svg width="12" height="8" viewBox="0 0 12 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 1l5 5 5-5"/></svg>
            </button>
          </div>
          <div class="ab-ctl-drawer__options"></div>
          <button type="button" class="ab-ctl-drawer__add-btn"></button>
        </div>
      </div>
    `;

    drawer.querySelector('.ab-ctl-drawer__overlay').addEventListener('click', () => this._closeDrawer());
    drawer.querySelector('.ab-ctl-drawer__close').addEventListener('click', () => this._closeDrawer());
    drawer.querySelector('.ab-ctl-drawer__add-btn').addEventListener('click', () => this._drawerAddClick());
    drawer.querySelector('.ab-ctl-drawer__img-prev').addEventListener('click', () => this._showImage(this._drawerImageIndex - 1, -1));
    drawer.querySelector('.ab-ctl-drawer__img-next').addEventListener('click', () => this._showImage(this._drawerImageIndex + 1, 1));
    drawer.querySelector('.ab-ctl-drawer__desc-toggle').addEventListener('click', () => {
      const toggle = drawer.querySelector('.ab-ctl-drawer__desc-toggle');
      const desc = drawer.querySelector('.ab-ctl-drawer__desc');
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const lineH = parseFloat(getComputedStyle(desc).lineHeight);
      if (expanded) {
        desc.style.maxHeight = (lineH * 4) + 'px';
        desc.classList.add('ab-ctl-drawer__desc--collapsed');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        desc.style.maxHeight = desc.scrollHeight + 'px';
        desc.classList.remove('ab-ctl-drawer__desc--collapsed');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
    drawer.querySelector('.ab-ctl-drawer__options').addEventListener('change', (e) => {
      const input = e.target.closest('input[data-option-type]');
      if (input) this._drawerSelectOption(input);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.drawer.classList.contains('ab-ctl-drawer--open')) {
        this._closeDrawer();
      }
    });

    document.body.appendChild(drawer);
    return drawer;
  }

  _openDrawer(uv, card) {
    this.activeCard = card;
    this._drawerCurrentUv = uv;

    const currentVarId = String(card.dataset.selectedId || uv.defaultVariantId);
    let currentVar = uv.allVariants?.find(v => String(v.id) === currentVarId);

    // Auto-select first available variant if default is unavailable
    if (currentVar && !currentVar.available) {
      currentVar = uv.allVariants?.find(v => v.available) || currentVar;
    }

    this._drawerCurrentVariantId = currentVar ? String(currentVar.id) : currentVarId;
    this._drawerCurrentSize = currentVar?.size || uv.defaultSize;
    this._drawerCurrentExtra = currentVar?.extra || uv.defaultExtra;
    this._drawerImages = uv.images?.length ? uv.images : (uv.imageUrl ? [uv.imageUrl] : []);
    this._drawerImageIndex = 0;

    const isSelected = card.querySelector('.ab-complete-the-look__btn')?.getAttribute('aria-pressed') === 'true';
    this._renderDrawer(uv, isSelected);

    this.drawer.setAttribute('aria-hidden', 'false');
    this.drawer.classList.add('ab-ctl-drawer--open');
    document.body.style.overflow = 'hidden';
    this.drawer.querySelector('.ab-ctl-drawer__close')?.focus();

  }

  _renderDrawer(uv, isSelected) {
    const currentVar = uv.allVariants?.find(v => String(v.id) === String(this._drawerCurrentVariantId));

    const alt = this._esc(uv.imageAlt || uv.productTitle || '');
    const track = this.drawer.querySelector('.ab-ctl-drawer__img-track');
    const isMobile = window.innerWidth < 750;
    track.style.transition = 'none';
    track.style.transform = isMobile ? '' : 'translateX(0)';
    track.innerHTML = this._drawerImages.map(src =>
      `<img class="ab-ctl-drawer__img" src="${src}" alt="${alt}">`
    ).join('');

    const hasMultiple = this._drawerImages.length > 1;
    this.drawer.querySelectorAll('.ab-ctl-drawer__img-nav').forEach(btn => {
      btn.style.display = (hasMultiple && !isMobile) ? '' : 'none';
    });
    this._updateImgNav();

    const titleEl = this.drawer.querySelector('.ab-ctl-drawer__title');
    titleEl.href = uv.productUrl;
    titleEl.textContent = uv.productTitle;
    this._updateDrawerVariantSummary();

    const price = currentVar?.priceFormatted || uv.priceFormatted;
    const comparePrice = currentVar?.compareAtPriceFormatted || uv.compareAtPriceFormatted;
    const onSale = currentVar !== undefined ? currentVar.onSale : uv.onSale;
    this._updateDrawerPrices(price, comparePrice, onSale);

    const desc = uv.description || '';
    const descEl = this.drawer.querySelector('.ab-ctl-drawer__desc');
    const descToggle = this.drawer.querySelector('.ab-ctl-drawer__desc-toggle');
    descEl.innerHTML = desc;
    descEl.classList.remove('ab-ctl-drawer__desc--collapsed');
    descEl.style.transition = 'none';
    descEl.style.maxHeight = 'none';
    if (desc) {
      void descEl.offsetHeight;
      const lineH = parseFloat(getComputedStyle(descEl).lineHeight);
      const collapsedH = lineH * 4;
      if (descEl.scrollHeight > collapsedH + 2) {
        descEl.style.maxHeight = collapsedH + 'px';
        descEl.classList.add('ab-ctl-drawer__desc--collapsed');
        descToggle.removeAttribute('hidden');
        descToggle.setAttribute('aria-expanded', 'false');
      } else {
        descEl.style.maxHeight = '';
        descToggle.setAttribute('hidden', '');
      }
      requestAnimationFrame(() => { descEl.style.transition = ''; });
    } else {
      descEl.style.maxHeight = '';
      descToggle.setAttribute('hidden', '');
    }

    const optionsEl = this.drawer.querySelector('.ab-ctl-drawer__options');
    optionsEl.innerHTML = this._buildDrawerOptionsHtml(uv);

    const addBtn = this.drawer.querySelector('.ab-ctl-drawer__add-btn');
    const isAvailable = currentVar ? currentVar.available !== false : true;
    addBtn.disabled = !isAvailable;
    addBtn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    this._updateAddBtnText(addBtn, isSelected, price, isAvailable);
  }

  _isOptionAvailable(uv, type, value) {
    if (!uv?.allVariants?.length) return true;
    return uv.allVariants.some(v => {
      if (!v.available) return false;
      if (type === 'size') {
        return v.size === value && (!this._drawerCurrentExtra || v.extra === this._drawerCurrentExtra);
      }
      return v.extra === value && (!this._drawerCurrentSize || v.size === this._drawerCurrentSize);
    });
  }

  _buildDrawerOptionsHtml(uv) {
    const pid = uv.productId;
    const buildGroup = (values, type, activeVal, label, optType) => {
      if (!values?.length) return '';
      const isSwatch = optType === 'color' || optType === 'hardware';
      const groupName = `ab-ctl-${pid}-${type}`;
      const labelHtml = label ? `<span class="ab-ctl-drawer__option-label">${this._esc(label)}</span>` : '';
      const inputs = values.map((val, i) => {
        const id = `${groupName}-${i}`;
        const swatch = uv.swatches?.[val];
        const isChecked = val === activeVal ? 'checked' : '';
        const isAvailable = this._isOptionAvailable(uv, type, val);
        const disabledAttr = isAvailable ? '' : 'disabled';
        const unavailableClass = isAvailable ? '' : 'ab-ctl-option-unavailable';
        if (isSwatch && swatch) {
          return `<input type="radio" id="${id}" name="${groupName}" value="${this._esc(val)}"
            class="ab-ctl-hidden-radio" data-option-type="${type}" ${isChecked} ${disabledAttr}>
          <label for="${id}" class="color__swatch color__swatch--round ${unavailableClass}"
            style="--swatch-background-image: url('${swatch.image}'); --swatch-background-color: ${swatch.color};">
            <span class="color__swatch-dot"></span>
            <span class="color__swatch-tooltip">${this._esc(val)}</span>
          </label>`;
        }
        return `<input type="radio" id="${id}" name="${groupName}" value="${this._esc(val)}"
          class="ab-ctl-hidden-radio" data-option-type="${type}" ${isChecked} ${disabledAttr}>
        <label for="${id}" class="${unavailableClass}">${this._esc(val)}</label>`;
      }).join('');
      return `<div class="ab-ctl-drawer__option-group">${labelHtml}<div class="product-form__input ab-ctl-drawer__option-btns">${inputs}</div></div>`;
    };

    return buildGroup(uv.sizes, 'size', this._drawerCurrentSize, uv.sizeLabel, uv.sizeType)
         + buildGroup(uv.extraOptions, 'extra', this._drawerCurrentExtra, uv.extraLabel, uv.extraType);
  }

  _drawerSelectOption(input) {
    const type = input.dataset.optionType;
    const value = input.value;

    if (type === 'size') this._drawerCurrentSize = value;
    else this._drawerCurrentExtra = value;

    const match = this._findDrawerVariant();
    if (!match) return;

    const wasSelected = this.drawer.querySelector('.ab-ctl-drawer__add-btn')?.getAttribute('aria-pressed') === 'true';
    this._drawerCurrentVariantId = String(match.id);

    if (match.imageUrl && this._drawerImages.length <= 1) {
      const img = this.drawer.querySelector('.ab-ctl-drawer__img');
      if (img) img.src = match.imageUrl;
    }

    this._updateDrawerPrices(match.priceFormatted, match.compareAtPriceFormatted, match.onSale);
    this._updateDrawerVariantSummary();

    // Re-render options so disabled states update for the other axis
    const optionsEl = this.drawer.querySelector('.ab-ctl-drawer__options');
    optionsEl.innerHTML = this._buildDrawerOptionsHtml(this._drawerCurrentUv);

    const addBtn = this.drawer.querySelector('.ab-ctl-drawer__add-btn');
    const isAvailable = match.available !== false;
    addBtn.disabled = !isAvailable;
    this._updateAddBtnText(addBtn, wasSelected, match.priceFormatted, isAvailable);

    if (wasSelected && this.activeCard) {
      this.activeCard.dataset.selectedId = this._drawerCurrentVariantId;
      this._updateCardVariant(this.activeCard, this._drawerCurrentUv, match);
    }
  }

  _findDrawerVariant() {
    const uv = this._drawerCurrentUv;
    if (!uv?.allVariants?.length) return null;
    return uv.allVariants.find(v =>
      (!this._drawerCurrentSize || v.size === this._drawerCurrentSize) &&
      (!this._drawerCurrentExtra || v.extra === this._drawerCurrentExtra)
    ) || uv.allVariants[0];
  }

  _updateDrawerPrices(price, comparePrice, onSale) {
    const pricesEl = this.drawer.querySelector('.ab-ctl-drawer__prices');
    pricesEl.innerHTML = onSale
      ? `<s class="ab-ctl-price ab-ctl-price--compare">${comparePrice}</s><span class="ab-ctl-price ab-ctl-price--current ab-ctl-price--sale">${price}</span>`
      : `<span class="ab-ctl-price ab-ctl-price--current">${price}</span>`;
  }

  _updateAddBtnText(btn, isSelected, price, isAvailable = true) {
    if (!isAvailable) {
      btn.textContent = 'Sold out';
      return;
    }
    const checkedLabel = this.el.dataset.checkedLabel || 'In your order';
    btn.textContent = isSelected ? checkedLabel : (price ? `Add - ${price}` : 'Add');
  }

  _updateDrawerVariantSummary() {
    const el = this.drawer.querySelector('.ab-ctl-drawer__variant-summary');
    if (!el) return;
    const match = this._findDrawerVariant();
    const title = match?.title;
    el.textContent = (title && title !== 'Default Title') ? title : '';
  }

  _updateCardVariant(card, uv, variant) {
    if (!card || !variant) return;
    let varTitleEl = card.querySelector('.ab-complete-the-look__variant-title');
    const newTitle = (variant.title && variant.title !== 'Default Title') ? variant.title : (uv?.variantTitle || null);
    if (newTitle) {
      if (!varTitleEl) {
        varTitleEl = document.createElement('p');
        varTitleEl.className = 'ab-complete-the-look__variant-title';
        card.querySelector('.ab-complete-the-look__product-title')?.after(varTitleEl);
      }
      varTitleEl.textContent = newTitle;
    }
    const pricesEl = card.querySelector('.ab-complete-the-look__prices');
    if (pricesEl) {
      const compareHtml = variant.onSale
        ? `<s class="ab-ctl-price ab-ctl-price--compare">${variant.compareAtPriceFormatted}</s>`
        : '';
      pricesEl.innerHTML = `${compareHtml}<span class="ab-ctl-price ab-ctl-price--current${variant.onSale ? ' ab-ctl-price--sale' : ''}">${variant.priceFormatted}</span>`;
    }
  }

  _drawerAddClick() {
    if (!this.activeCard) return;

    const card = this.activeCard;
    const currentVar = this._drawerCurrentUv?.allVariants?.find(
      v => String(v.id) === String(this._drawerCurrentVariantId)
    );

    // Update card visuals optimistically
    const cardBtn = card.querySelector('.ab-complete-the-look__btn');
    const label = card.querySelector('.ab-ctl-checked-label');
    card.dataset.selectedId = this._drawerCurrentVariantId;
    cardBtn?.setAttribute('aria-pressed', 'true');
    label?.classList.add('ab-ctl-checked-label--visible');
    this._updateCardVariant(card, this._drawerCurrentUv, currentVar);

    // Auto-reset card after 10 seconds
    setTimeout(() => {
      cardBtn?.setAttribute('aria-pressed', 'false');
      label?.classList.remove('ab-ctl-checked-label--visible');
      card.dataset.selectedId = '';
    }, 10000);

    // Close CTL drawer before triggering cart add
    this._closeDrawer();

    const mainIdInput = document.querySelector('[data-type="add-to-cart-form"] [name="id"]');
    const mainSubmitBtn = document.querySelector('[data-type="add-to-cart-form"] [name="add"]');

    if (mainIdInput && mainSubmitBtn && mainSubmitBtn.getAttribute('aria-disabled') !== 'true') {
      const originalId = mainIdInput.value;
      mainIdInput.value = this._drawerCurrentVariantId;
      mainSubmitBtn.click(); // Dawn reads FormData synchronously here, then handles cart open
      mainIdInput.value = originalId;
      // Strip the loading animation from the main ATC button — the customer didn't click it
      requestAnimationFrame(() => requestAnimationFrame(() => {
        mainSubmitBtn.classList.remove('loading');
        mainSubmitBtn.removeAttribute('aria-disabled');
        mainSubmitBtn.disabled = false;
      }));
    } else {
      // Fallback: own fetch + manual cart open
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(this._drawerCurrentVariantId), quantity: 1 }] })
      }).then(() => this._openShopifyCart()).catch(() => {});
    }
  }

  async _openShopifyCart() {
    // Update section HTML (non-fatal if it fails)
    try {
      const sections = await fetch('/?sections=cart-drawer,cart-icon-bubble').then(r => r.json());
      const parser = new DOMParser();

      const bubbleEl = document.querySelector('#cart-icon-bubble');
      if (bubbleEl && sections['cart-icon-bubble']) {
        const newBubble = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('#cart-icon-bubble');
        if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
      }

      const drawerEl = document.querySelector('#CartDrawer');
      if (drawerEl && sections['cart-drawer']) {
        const newDrawer = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        if (newDrawer) drawerEl.innerHTML = newDrawer.innerHTML;
      }
    } catch { /* section update failure is non-fatal */ }

    // Open the cart drawer — always runs even if section update failed
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      (document.querySelector('[aria-controls="CartDrawer"]') || document.querySelector('#cart-icon-bubble'))?.click();
    }
  }

  _showImage(index, dir = 0) {
    if (!this._drawerImages.length) return;
    const newIdx = Math.max(0, Math.min(this._drawerImages.length - 1, index));
    this._drawerImageIndex = newIdx;
    const track = this.drawer.querySelector('.ab-ctl-drawer__img-track');
    if (track) {
      if (window.innerWidth < 750) {
        track.children[newIdx]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      } else {
        track.style.transition = dir ? 'transform 0.35s ease' : 'none';
        track.style.transform = `translateX(${-newIdx * 100}%)`;
      }
    }
    this._updateImgNav();
  }

  _updateImgNav() {
    const prevBtn = this.drawer.querySelector('.ab-ctl-drawer__img-prev');
    const nextBtn = this.drawer.querySelector('.ab-ctl-drawer__img-next');
    if (prevBtn) prevBtn.disabled = this._drawerImageIndex === 0;
    if (nextBtn) nextBtn.disabled = this._drawerImageIndex >= this._drawerImages.length - 1;
  }

  _closeDrawer() {
    this.drawer.setAttribute('aria-hidden', 'true');
    this.drawer.classList.remove('ab-ctl-drawer--open');
    document.body.style.overflow = '';
    this.activeCard = null;
  }

  // ── Cards ────────────────────────────────────────────────────────────────────

  _attachCardListeners(container) {
    container?.addEventListener('click', (e) => {
      const card = e.target.closest('.ab-complete-the-look__card');
      if (!card) return;

      const idInput = document.querySelector('[data-type="add-to-cart-form"] [name="id"]');
      const mainVariantId = String(idInput?.value || new URLSearchParams(location.search).get('variant') || '');
      const upsells = this.data[mainVariantId] || [];
      const uv = upsells.find(u => String(u.productId) === String(card.dataset.productId));
      if (uv) this._openDrawer(uv, card);
    });
  }

  _attachNavListeners() {
    this.prevBtn?.addEventListener('click', () => this._slide(-1));
    this.nextBtn?.addEventListener('click', () => this._slide(1));
  }

  _attachSwipe() {
    const wrapper = this.el.querySelector('.ab-complete-the-look__slider-wrapper');
    if (!wrapper) return;
    let startX = 0;
    wrapper.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    wrapper.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) this._slide(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  _slide(direction) {
    const cards = this.cardsEl.querySelectorAll('.ab-complete-the-look__card');
    const maxIndex = Math.max(0, cards.length - this.cardsPerView);
    this.currentIndex = Math.max(0, Math.min(maxIndex, this.currentIndex + direction));

    const gap = parseFloat(getComputedStyle(this.cardsEl).columnGap) || 0;
    const cardWidth = (cards[0]?.offsetWidth || 0) + gap;
    this.cardsEl.style.transform = `translateX(-${this.currentIndex * cardWidth}px)`;
    this._updateNav();
  }

  _updateNav() {
    const total = this.cardsEl?.querySelectorAll('.ab-complete-the-look__card').length || 0;
    const maxIndex = Math.max(0, total - this.cardsPerView);
    if (this.prevBtn) this.prevBtn.disabled = this.currentIndex === 0;
    if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= maxIndex || total <= this.cardsPerView;
  }

  _watchVariantChange() {
    const picker = document.querySelector('variant-radios, variant-selects');
    if (!picker) return;
    picker.addEventListener('change', () => {
      requestAnimationFrame(() => {
        const idInput = document.querySelector('[data-type="add-to-cart-form"] [name="id"]');
        const variantId = idInput?.value || new URLSearchParams(location.search).get('variant');
        if (variantId) this._updateCards(String(variantId));
      });
    });
  }

  _updateCards(variantId) {
    const upsells = this.data[variantId] || [];
    if (!upsells.length) {
      this.el.classList.add('ab-complete-the-look--empty');
      return;
    }
    this.el.classList.remove('ab-complete-the-look--empty');

    this.cardsEl.innerHTML = upsells.map(uv => this._buildCardHtml(uv)).join('');

    this.currentIndex = 0;
    this.cardsEl.style.transform = '';
    this._updateNav();
  }

  _buildCardHtml(uv) {
    const checkedLabel = this._esc(this.el.dataset.checkedLabel || '');
    const imgHtml = uv.imageUrl
      ? `<img class="ab-complete-the-look__img" src="${uv.imageUrl}" alt="${this._esc(uv.imageAlt)}" width="400" height="500" loading="lazy">`
      : '';
    const variantTitleHtml = uv.variantTitle
      ? `<p class="ab-complete-the-look__variant-title">${this._esc(uv.variantTitle)}</p>`
      : '';
    const compareHtml = uv.onSale
      ? `<s class="ab-ctl-price ab-ctl-price--compare">${uv.compareAtPriceFormatted}</s>`
      : '';

    return `<li class="ab-complete-the-look__card"
      data-variant-id="${uv.variantId}"
      data-selected-id="${uv.defaultVariantId}"
      data-product-id="${uv.productId}">
      <div class="ab-complete-the-look__image-wrap">
        ${imgHtml}
        <button type="button" class="ab-complete-the-look__btn" aria-pressed="false"
          aria-label="${this._esc(uv.productTitle)}" data-variant-id="${uv.variantId}">
          <span class="ab-ctl-icon ab-ctl-icon--add" aria-hidden="true">
            <svg fill="#000000" width="14px" height="14px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5,12H19M12,5V19" style="fill: none; stroke: rgb(0, 0, 0); stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"></path></svg>
          </span>
          <span class="ab-ctl-icon ab-ctl-icon--check" aria-hidden="true">
            <svg fill="#000000" width="14px" height="14px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18.71,7.21a1,1,0,0,0-1.42,0L9.84,14.67,6.71,11.53A1,1,0,1,0,5.29,13l3.84,3.84a1,1,0,0,0,1.42,0l8.16-8.16A1,1,0,0,0,18.71,7.21Z"/></svg>
          </span>
        </button>
        <span class="ab-ctl-checked-label">${checkedLabel}</span>
      </div>
      <div class="ab-complete-the-look__info">
        <a class="ab-complete-the-look__product-title" href="${this._esc(uv.productUrl)}">${this._esc(uv.productTitle)}</a>
        ${variantTitleHtml}
        <div class="ab-complete-the-look__prices">
          ${compareHtml}
          <span class="ab-ctl-price ab-ctl-price--current${uv.onSale ? ' ab-ctl-price--sale' : ''}">${uv.priceFormatted}</span>
        </div>
      </div>
    </li>`;
  }

  _esc(str) {
    return String(str ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
}

document.querySelectorAll('[id^="ab-complete-the-look-"]').forEach(el => new AbCompleteTheLook(el));
